import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { PTSMasterScreen_ScreenContext } from "../ptsmasterscreen/ptsmasterscreen-context";

declare let window: any;

export interface IProjeler_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProjeler_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GET_PROJE_LISTESI: any[];
  GET_PROJE_LISTESI_dummy: any[];
  PROJE_DASHBOARD_GENEL_STAT: any[];
  PROJE_DASHBOARD_GENEL_STAT_dummy: any[];
  GET_SON_10_PROJE: any[];
  GET_SON_10_PROJE_dummy: any[];
  GET_PROJEYONETICI_USERS: any[];
  GET_PROJEYONETICI_USERS_dummy: any[];
  isComp506025Visible: "visible" | "hidden";
  isComp452154Visible: "visible" | "hidden";
  isComp637541Visible: "visible" | "hidden";
  isCompprojeler_81401AuthorizationVisible: "visible" | "hidden";
}

export class Projeler_ScreenBase extends React.PureComponent<
  IProjeler_ScreenProps,
  any
> {
  static contextType = PTSMasterScreen_ScreenContext;
  declare context: React.ContextType<typeof PTSMasterScreen_ScreenContext>;
  projeler_64322_value_kuikaTableRef: React.RefObject<any>;
  projeler_582700_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_854840_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_807417_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_353688_value_kuikaGalleryViewRef: React.RefObject<any>;
  projeler_410807_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_765587_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_758987_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_1029_value_kuikaGalleryViewRef: React.RefObject<any>;
  projeler_979206_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_78348_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_412200_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_415298_value_kuikaGalleryViewRef: React.RefObject<any>;
  projeler_342238_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_294525_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_387356_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_471373_value_kuikaGalleryViewRef: React.RefObject<any>;
  projeler_739999_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_414991_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_484476_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_83115_value_kuikaGalleryViewRef: React.RefObject<any>;
  projeler_323541_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_24529_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_797059_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_140449_value_kuikaGalleryViewRef: React.RefObject<any>;
  projeler_807978_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_71848_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_463334_value_kuikaSelectBoxRef: React.RefObject<any>;
  projeler_461668_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "4b5c1b7d-67e1-47f2-97f3-07b4f73446f7",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 900204, PropertyName: "tab", Value: "📊 Dashboard" },
        { Id: 15196, PropertyName: "value", Value: "Toplam Proje" },
        { Id: 462819, PropertyName: "value", Value: "Devam Eden" },
        { Id: 196982, PropertyName: "value", Value: "Beklemede" },
        { Id: 464094, PropertyName: "value", Value: "Arıza Kaydı" },
        { Id: 448613, PropertyName: "value", Value: "Son Projeler" },
        { Id: 663363, PropertyName: "label", Value: "Yeni Proje" },
        { Id: 921216, PropertyName: "title", Value: "  Proje Adı" },
        { Id: 656055, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 708714, PropertyName: "title", Value: "Kategori" },
        { Id: 777042, PropertyName: "value", Value: "[datafield:kategori]" },
        { Id: 248426, PropertyName: "title", Value: "Müşteri" },
        { Id: 92721, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 537723, PropertyName: "title", Value: "Durum" },
        { Id: 506025, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 452154, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 637541, PropertyName: "value", Value: "Beklemede" },
        { Id: 383949, PropertyName: "title", Value: "İlerleme" },
        { Id: 798557, PropertyName: "title", Value: "Başlangıç" },
        {
          Id: 658989,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 865940, PropertyName: "title", Value: "Bitiş" },
        {
          Id: 646952,
          PropertyName: "value",
          Value: "[datafield:tahminibitis]",
        },
        { Id: 549263, PropertyName: "title", Value: "İşlemler" },
        { Id: 394366, PropertyName: "tab", Value: "🏠 Çatı GES" },
        { Id: 92451, PropertyName: "value", Value: "🏠 Çatı GES Projeleri" },
        { Id: 907370, PropertyName: "label", Value: "Yeni Çatı GES Projesi" },
        { Id: 971353, PropertyName: "tab", Value: "⚡ Öz Tüketim" },
        { Id: 656366, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 97677,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 728287, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 582700, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 328567, PropertyName: "value", Value: "Durum" },
        { Id: 854840, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 747251, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 807417,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 564595, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 539066,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 539066,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 353688,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 797031, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 920308, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 851274, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 154800, PropertyName: "value", Value: "Müşteri" },
        { Id: 576518, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 505648, PropertyName: "value", Value: "Bütçe" },
        { Id: 624021, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 354535, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 115612,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 634129, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 479138,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 23835, PropertyName: "tab", Value: "📋 Proje Onaylı" },
        { Id: 993133, PropertyName: "tab", Value: "🌿 Arazi GES" },
        { Id: 12794, PropertyName: "value", Value: "Arazi GES içerik alanı" },
        { Id: 103347, PropertyName: "label", Value: "Yeni Arazi GES Projesi" },
        { Id: 958351, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 579296,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 988359, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 410807, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 229210, PropertyName: "value", Value: "Durum" },
        { Id: 765587, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 453025, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 758987,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 415815, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 230882,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 230882,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 1029,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 422675, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 143481, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 95728, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 597695, PropertyName: "value", Value: "Müşteri" },
        { Id: 127942, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 722115, PropertyName: "value", Value: "Bütçe" },
        { Id: 570861, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 313936, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 428909,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 456353, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 684902,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 948236, PropertyName: "tab", Value: "💧 Tarımsal Sulama" },
        { Id: 456502, PropertyName: "value", Value: "Tarımsal Sulama" },
        {
          Id: 655489,
          PropertyName: "label",
          Value: "Yeni Tarımsal Sulama Projesi",
        },
        { Id: 87182, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 998883,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 90951, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 979206, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 158447, PropertyName: "value", Value: "Durum" },
        { Id: 78348, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 498122, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 412200,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 486025, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 715257,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 715257,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 415298,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 314306, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 204878, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 743946, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 508755, PropertyName: "value", Value: "Müşteri" },
        { Id: 502598, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 83470, PropertyName: "value", Value: "Bütçe" },
        { Id: 447756, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 682121, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 568363,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 740869, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 2216,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 997442, PropertyName: "tab", Value: "🔌 Araç Şarj İstasyonu" },
        { Id: 818300, PropertyName: "value", Value: "Araç Şarj İstasyonu" },
        { Id: 626289, PropertyName: "label", Value: "Yeni A.Ş.İ. Projesi" },
        { Id: 901468, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 203811,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 508670, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 342238, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 969926, PropertyName: "value", Value: "Durum" },
        { Id: 294525, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 291644, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 387356,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 452041, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 876805,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 876805,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 471373,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 614875, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 402080, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 302705, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 164624, PropertyName: "value", Value: "Müşteri" },
        { Id: 368129, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 404195, PropertyName: "value", Value: "Bütçe" },
        { Id: 23478, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 351988, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 301392,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 760327, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 81543,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 167900, PropertyName: "tab", Value: "🏡 Akıllı EV" },
        { Id: 730687, PropertyName: "value", Value: "Akıllı Ev Sistemleri" },
        { Id: 971342, PropertyName: "label", Value: "Yeni A.E. Projesi" },
        { Id: 894230, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 585731,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 529872, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 739999, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 744234, PropertyName: "value", Value: "Durum" },
        { Id: 414991, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 236063, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 484476,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 4470, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 918718,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 918718,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 83115,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 431331, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 289995, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 564521, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 621336, PropertyName: "value", Value: "Müşteri" },
        { Id: 843786, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 556561, PropertyName: "value", Value: "Bütçe" },
        { Id: 529900, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 762673, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 683323,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 185494, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 801044,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 185940, PropertyName: "tab", Value: "🏪 HOMEX" },
        { Id: 399598, PropertyName: "value", Value: "HOMEX" },
        { Id: 511405, PropertyName: "label", Value: "Yeni HOMEX Projesi" },
        { Id: 69390, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 451833,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 810418, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 323541, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 983992, PropertyName: "value", Value: "Durum" },
        { Id: 24529, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 956209, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 797059,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 957046, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 559803,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 559803,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 140449,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 711501, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 562048, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 701831, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 922090, PropertyName: "value", Value: "Müşteri" },
        { Id: 626314, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 342050, PropertyName: "value", Value: "Bütçe" },
        { Id: 733800, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 208557, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 370977,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 817, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 117720,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 182789, PropertyName: "tab", Value: "⚠️ Arıza Takip" },
        { Id: 658358, PropertyName: "value", Value: "Arıza Takip" },
        { Id: 266336, PropertyName: "value", Value: "Proje Adı" },
        {
          Id: 601900,
          PropertyName: "placeholder",
          Value: "Proje Adı ile Ara..",
        },
        { Id: 466414, PropertyName: "value", Value: "Tesis Adı" },
        { Id: 807978, PropertyName: "placeholder", Value: "Tesis Adı..." },
        { Id: 337333, PropertyName: "value", Value: "Durum" },
        { Id: 71848, PropertyName: "placeholder", Value: "Durum..." },
        { Id: 155827, PropertyName: "value", Value: "Proje Yöneticis" },
        {
          Id: 463334,
          PropertyName: "placeholder",
          Value: "Proje Yöneticisi...",
        },
        { Id: 150085, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 110419,
          PropertyName: "startDatePlaceholder",
          Value: "Başlanış Tarihi",
        },
        {
          Id: 110419,
          PropertyName: "endDatePlaceholder",
          Value: "Bitiş Tarihi",
        },
        {
          Id: 461668,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 115335, PropertyName: "value", Value: "[datafield:projekodu]" },
        { Id: 777405, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 408280, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 327003, PropertyName: "value", Value: "Müşteri" },
        { Id: 229264, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 183585, PropertyName: "value", Value: "Bütçe" },
        { Id: 665084, PropertyName: "value", Value: "[datafield:butce]" },
        { Id: 591512, PropertyName: "value", Value: "Proje Yöneticisi" },
        {
          Id: 31039,
          PropertyName: "value",
          Value: "[datafield:projeyoneticisiadi]",
        },
        { Id: 246476, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 414948,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.projeler_64322_value_kuikaTableRef = React.createRef();
    this.projeler_97677_value_kuikaTextInputRef = React.createRef();
    this.projeler_582700_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_854840_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_807417_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_353688_value_kuikaGalleryViewRef = React.createRef();
    this.projeler_579296_value_kuikaTextInputRef = React.createRef();
    this.projeler_410807_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_765587_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_758987_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_1029_value_kuikaGalleryViewRef = React.createRef();
    this.projeler_998883_value_kuikaTextInputRef = React.createRef();
    this.projeler_979206_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_78348_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_412200_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_415298_value_kuikaGalleryViewRef = React.createRef();
    this.projeler_203811_value_kuikaTextInputRef = React.createRef();
    this.projeler_342238_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_294525_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_387356_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_471373_value_kuikaGalleryViewRef = React.createRef();
    this.projeler_585731_value_kuikaTextInputRef = React.createRef();
    this.projeler_739999_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_414991_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_484476_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_83115_value_kuikaGalleryViewRef = React.createRef();
    this.projeler_451833_value_kuikaTextInputRef = React.createRef();
    this.projeler_323541_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_24529_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_797059_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_140449_value_kuikaGalleryViewRef = React.createRef();
    this.projeler_601900_value_kuikaTextInputRef = React.createRef();
    this.projeler_807978_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_71848_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_463334_value_kuikaSelectBoxRef = React.createRef();
    this.projeler_461668_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GET_PROJE_LISTESI: [],
      PROJE_DASHBOARD_GENEL_STAT: [],
      GET_SON_10_PROJE: [],
      GET_PROJEYONETICI_USERS: [],
      isComp506025Visible: "hidden",
      isComp452154Visible: "hidden",
      isComp637541Visible: "hidden",
      isCompprojeler_81401AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "projeler",
        "ptsmasterscreen_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.ProjelerPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompprojeler_81401AuthorizationVisible",
      []
    );

    KuikaAppManager.calculateAndSetBodyHeight(
      "projeler",
      "ptsmasterscreen_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "projeler",
      "ptsmasterscreen_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProjelerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  ProjelerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROJE_DASHBOARD_GENEL_STAT =
      result?.data.projE_DASHBOARD_GENEL_STAT;
    formVars.projeler_474634_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
        : null
    );
    formVars.projeler_767561_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
        : null
    );
    formVars.projeler_714167_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
        : null
    );
    formVars.projeler_82563_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
        : null
    );
    stateVars.GET_SON_10_PROJE = result?.data.geT_SON_10_PROJE;

    stateVars.GET_PROJEYONETICI_USERS = result?.data.geT_PROJEYONETICI_USERS;

    formVars.projeler_807417_options = stateVars.GET_PROJEYONETICI_USERS;

    formVars.projeler_758987_options = stateVars.GET_PROJEYONETICI_USERS;

    formVars.projeler_412200_options = stateVars.GET_PROJEYONETICI_USERS;

    formVars.projeler_387356_options = stateVars.GET_PROJEYONETICI_USERS;

    formVars.projeler_484476_options = stateVars.GET_PROJEYONETICI_USERS;

    formVars.projeler_797059_options = stateVars.GET_PROJEYONETICI_USERS;

    formVars.projeler_463334_options = stateVars.GET_PROJEYONETICI_USERS;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.projeler_474634_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
        : null
    );

    formVars.projeler_767561_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
        : null
    );

    formVars.projeler_714167_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
        : null
    );

    formVars.projeler_82563_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
        : null
    );

    stateVars.dataSource_64322 =
      stateVars.GET_SON_10_PROJE ?? this.state.GET_SON_10_PROJE;
    stateVars.isComp506025Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "projeler_64322_value", "durum"),
        "Tamamlandi"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp452154Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "projeler_64322_value", "durum"),
        "Devam Ediyor"
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(this, "projeler_64322_value", "durum"),
          "Taslak"
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp637541Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "projeler_64322_value", "durum"),
        "Beklemede"
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_807417 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_807417 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    stateVars.dataSource_758987 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_758987 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    stateVars.dataSource_412200 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_412200 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    stateVars.dataSource_387356 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_387356 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    stateVars.dataSource_484476 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_484476 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    stateVars.dataSource_797059 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_797059 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    stateVars.dataSource_463334 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_463334 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProjelerComponent_663363_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(null, "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "27317",
      null,
      null,
      "true",
      "1600px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_393990_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ProjeEdit",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "projeler_64322_value", "kategori"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "ProjeEdit",
      "ProjeID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "projeler_64322_value", "id"),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "ProjeEdit",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "949248",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_394366_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_394366_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_394366_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_394366_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_907370_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "925734",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_97677_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_97677_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_97677_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_97677_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_582700_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_582700_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_582700_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_582700_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_854840_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_854840_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_854840_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_854840_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_807417_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_807417_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_807417_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_807417_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_539066_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_539066_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_539066_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_539066_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_924758_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "CatiGesOnSurecler",
      "ProjeID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "projeler_353688_value", "id"),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "CatiGesOnSurecler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "456254",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_993133_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_758987_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_765587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_410807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_579296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_993133_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_993133_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_993133_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_103347_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "803041",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_579296_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_758987_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_765587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_410807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_579296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_579296_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_579296_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_579296_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_410807_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_758987_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_765587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_410807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_579296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_410807_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_410807_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_410807_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_765587_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_758987_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_765587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_410807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_579296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_765587_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_765587_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_765587_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_758987_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_758987_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_765587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_410807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_579296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_758987_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_758987_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_758987_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_230882_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARAZI_GES", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_758987_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_765587_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_230882_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_410807_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_579296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_230882_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_230882_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_230882_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_948236_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("TARIMSAL_SULAMA", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_948236_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_948236_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_948236_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_655489_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("TARIMSAL_SULAMA", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "467429",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_665703_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarimsalSulamaOnSurecler",
      "ProjeID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "projeler_415298_value", "id"),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "TarimsalSulamaOnSurecler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "508257",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_997442_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("SARJ_ISTASYONU", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_997442_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_997442_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_997442_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_167900_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("AKILLI_EV", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_167900_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_167900_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_167900_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_971342_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("AKILLI_EV", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "218161",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_185940_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("HOMEX", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_185940_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_185940_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_185940_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_511405_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("HOMEX", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Projeler",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "167220",
      null,
      null,
      "true",
      "1200px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProjelerComponent_182789_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ARIZA_BAKIM", "string"),
        "string"
      ),
      YoneticisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_807417_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      Durum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_854840_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_539066_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TesisAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_582700_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "projeler_97677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Projeler/ProjelerComponent_182789_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJE_LISTESI = result?.data.geT_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProjelerComponent_182789_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProjelerComponent_182789_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_353688 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_1029 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_415298 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_471373 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_83115 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_140449 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    stateVars.dataSource_461668 =
      stateVars.GET_PROJE_LISTESI ?? this.state.GET_PROJE_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      27317, 949248, 925734, 456254, 803041, 467429, 508257, 218161, 167220,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProjelerPageInit();
    }
  }
}
